import React, { useEffect, useState } from 'react';


//Importacion funciones
import { elegirBloqueDePreguntas } from '../../Lib/funciones';

//Preguntas
import { preguntasEscaleraNutricion, preguntasEscaleraNutricion2, preguntasEscaleraNutricion3, preguntasEscaleraNutricion4, preguntasToboganNutricion, preguntasToboganNutricion2, preguntasToboganNutricion3, preguntasToboganNutricion4, preguntasTurnoExtraNutricion, preguntasTurnoExtraNutricion2, preguntasTurnoExtraNutricion3, preguntasTurnoExtraNutricion4 } from '../../Lib/listaPreguntasInteractivas';

//Importacion estilos
import '../../styles/cajonDePreguntas.css';

//Importacion componentes
import CountdownQuestion from '../CajonPreguntas/CuentaAtrasPregunta';

//Importacion de datos
import { estilos2 } from '../../Lib/estilosCuentaRegresiva';



export default function CajonPreguntas(props) {
  const [tamañoFuente, setTamañoFuente] = useState("2vw");

  const { temaElegido } = props;
  console.log("temaElegido", temaElegido);

  let colorGradiante = estilos2[Math.floor((Math.random() * 30) + 1)];

  const elegirPregunta = (objeto) => {
    //Generamos un numero aleatorio dependiendo la cantidad de preguntas que tengamos
    const randomValuePreguntas = Math.floor((Math.random() * Object.keys(objeto).length) + 1);
    //Generamos la variable para elegir aleatoriamente las preguntas mas adelante.
    let randomValueRespuestas;




    //Usando el numero random nos trae la pregunta elegida y la guardamos en la variable pregunta.
    let pregunta = objeto[randomValuePreguntas];


    //Generamos un array vacio donde posteriormente guardaremos las respuestas.
    let arrayRespuestas = [];
    //Generamos un ciclo while el cual se ejecutara las veces necesarias antes de llenar las opciones de respuesta en este caso 4.

    //Dentro del ciclo generamos un numero random y lo guardamos en la variable randomValueRespuestas posteriormente generamos un if que comprobara si nuestro array esta vacio creara la primera respuesta dentro del array, se ejecutara el ciclo de nuevo y posteriormente ira al else donde tendremos un if que comprobara si ese elemento existe dentro del array, si existe nos dara undefinded y despues volvera al ciclo hasta llenar con las cuatro opciones el array.
    while (arrayRespuestas.length < 4) {
      randomValueRespuestas = Math.floor((Math.random() * 4) + 1);
      if( arrayRespuestas.length === 0 ){
        arrayRespuestas.push(pregunta.respuestas[randomValueRespuestas]);
      }else{
        if(arrayRespuestas.find(element => element === pregunta.respuestas[randomValueRespuestas]) === undefined){
          arrayRespuestas.push(pregunta.respuestas[randomValueRespuestas]);
        }
      }
    }


  //Posteriormente nos daraun return que nos devuelve un array con la pregunta y un array mas que contiene cada respuesta.
    return [pregunta.pregunta, arrayRespuestas]
  }

//En una variable guardaremos las preguntas generadas en la funcion anterior con un map y las encerramos en un etiqueta div esa variable la pasamos en el JSX del componente y se renderiza.
let preguntaElecta = "";
if(temaElegido === "Nutrición"){
  preguntaElecta = elegirPregunta(elegirBloqueDePreguntas(props.tipoPreguntas, preguntasTurnoExtraNutricion, preguntasEscaleraNutricion, preguntasToboganNutricion));
}else if(temaElegido === "Nutrición-2"){
  preguntaElecta = elegirPregunta(elegirBloqueDePreguntas(props.tipoPreguntas, preguntasTurnoExtraNutricion2, preguntasEscaleraNutricion2, preguntasToboganNutricion2));
}else if(temaElegido === "Nutrición-3"){
  preguntaElecta = elegirPregunta(elegirBloqueDePreguntas(props.tipoPreguntas, preguntasTurnoExtraNutricion3, preguntasEscaleraNutricion3, preguntasToboganNutricion3));
}else if(temaElegido === "Nutrición-4"){
  preguntaElecta = elegirPregunta(elegirBloqueDePreguntas(props.tipoPreguntas, preguntasTurnoExtraNutricion4, preguntasEscaleraNutricion4, preguntasToboganNutricion4));
}

// console.log("PreguntaElecta", preguntaElecta);


// console.log("elegirbloquepreguntas",elegirBloqueDePreguntas(props.tipoPreguntas, preguntasTurnoExtraNutricion2, preguntasEscaleraNutricion2, preguntasToboganNutricion2));


// let preguntaElecta = elegirPregunta(elegirBloqueDePreguntas(props.tipoPreguntas, preguntasTurnoExtraNutricion2, preguntasEscaleraNutricion2, preguntasToboganNutricion2));

// console.log("R42",elegirBloqueDePreguntas(props.tipoPregunta, preguntasTurnoExtra, preguntasEscalera, preguntasTobogan));
// console.log("R43", props.tipoPreguntas);

let respuestas = preguntaElecta[1].map((respuesta, index) =>
    <div className={`cajonDePReguntas__div--respuestas cajonDePreguntas__div--respuesta${index}`} onClick={() => validarRepuesta(respuesta.tipo)}>
      {respuesta.respuesta}
    </div>
);



//Funcion que valida si la respuesta es correcta o no
const validarRepuesta = (boleano) => {
  //console.log("Probando funcion de validacion", boleano);
  if(boleano === true){
    props.fRenderizacionComponente(false, true);
  }else{
    props.fRenderizacionComponente(false, false);
  }
}

  const finalDelTiempoPregunta = (boleano) => {
    if(boleano === true){
      props.fRenderizacionComponente(false, false);
    }
  }


    useEffect(() => {
      //Si el mensaje es mas largo que 100 caracteres la fuente se hace mas pequeña para ser mas amigable
      if( preguntaElecta[0].length > 100){
        setTamañoFuente("1.5vw");
      }
    }, [])

  return (
    <div className="cajonDePreguntas__div--container">
      <div className="cajonDePreguntas__div--cajon" style={{background: `linear-gradient(-45deg, ${colorGradiante} 50%, rgba(255, 255, 255) 50%)`}}>
        <CountdownQuestion temporizadorPreguntas={props.temporizadorPreguntas} fFinalTiempoRespuesta={finalDelTiempoPregunta}/>
        <h2 className="cajonPreguntas__h2--pregunta">Pregunta</h2>
        <div className="cajonDePreguntas__div--pregunta" style={{fontSize: tamañoFuente}}>{preguntaElecta[0]}</div>
        {respuestas}
      </div>
    </div>
  )
};








